import React from 'react'
import ReactDOM from 'react-dom'
import './fix-search/index.css'
import App from './fix-search/App'
import reportWebVitals from './fix-session-manager/reportWebVitals'
import { ErrorBoundary } from './fix-session-manager/components/Error/ErrorBoundary'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { mode } from '@chakra-ui/theme-tools'

const gray = {
    "50": "#F2F2F2",
    "100": "#E2E8F0",
    "200": "#D2D8E0",
    "300": "#b4b4b4",
    "400": "#afafaf",
    "500": "#ADADAD",
    "600": "#666666",
    "700": "#4D4D4D",
    "800": "#354156",
    "900": "#1A1A1A"
}

const theme = extendTheme({
    config: {
        initialColorMode: 'dark',
        useSystemColorMode: false,
    },
    colors: {
        grayish: gray,
        // override built-in grey color palette, to make it more contrast on light theme,
        // but still automatically change text color for dark/light theme 
        gray: gray,
        chronicle: {
            navy: '#181f4c',
            ultramarine: '#0085BA',
            ultramarineLight: '#00AFF0',
            white: '#FFFFFF',
            orange: '#E29633'
        }
    },
    semanticTokens: {
        colors: {
            background: {
                default: '#FFFFFF',
                _dark: '#181f4c',
            },
            'secondary-background': {
                default: 'white',
                _dark: '#181f4c',
            },
            'odd-background': {
                default: '#E7e8e9',
                _dark: '#223067',
            },
            'selected-row-background': {
                default: '#ED9526'
            },
            'help-icons': {
                default: '#A5ADB7'
            },
            'service-red': {
                default: '#F12828'
            },
            'border': {
                default: 'gray.300',
                _dark: 'transparent',
            },
            'border-hover': {
                default: 'gray.600',
                _dark: 'whiteAlpha.500',
            },
            'table-container-border': {
                default: 'gray.100',
                _dark: 'gray.700',
            },
            'select-multi-value': {
                default: '#E0EAFF',
                _dark: '#5A7ABE'
            },
            'select-multi-value-remove': {
                default: '#E0EAFF',
                _dark: '#3A5A9E'
            },
            'form-section-background': {
                default: 'transparent',
                _dark: '#3956A040',
            },
            'form-section-border': {
                default: 'gray.200',
                _dark: 'transparent',
            },
            modal: {
                default: 'white',
                _dark: '#171f48',
            },
            input: {
                default: '#F7F8F9',
                _dark: '#394067'
            },
            input2: {
                default: '#dfdfdf', 
                _dark: '#394067'
            },
            selected: {
                default: '#c6c6c6', 
                _dark: '#253074'
            },
            'suggestion-highlight': {
                default: '#c2d6ff',
                _dark: '#2650AC'
            },
            'keyboard-key': {
                default: 'gray.300',
                _dark: 'gray.700'
            },
            'splitter': {
                default: '#A5ADB7',
                _dark: '#7084C0'
            }
        }
    },
    components: {
        FormLabel: { baseStyle: { fontWeight: 'normal' } }
    },
    styles: {
        global: (props) => ({
            ':root': {
                colorScheme: mode('light', 'dark')(props)
            }
        }),
    }
})

ReactDOM.render(
    <React.StrictMode>
        <ChakraProvider theme={theme}>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </ChakraProvider>
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
